/* eslint-disable consistent-return */
import { Button, Grid, MenuItem, FormLabel, Checkbox } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  getAddress,
  getCertificationAuthority,
  getDegreeLevel,
  getDegreeRequirements,
  getLangFormation,
  getStudyPlan,
  getCFAsBySchool,
  getTrainingDomains,
  getTrainingType,
  getOPCOsByCFA,
  updateFormation,
  getAllConventionModels,
} from '@webapps/business';
import {
  FormikAutocompletePx,
  FormikDatePicker,
  FormikTextField,
  TextField,
  TextFieldPx,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { LAST_DISPLOMA } from 'config/constants';

const EditFormation = ({
  formation,
  onChangeStepModal,
  onClose,
  refetchFormation,
}) => {

  const date = new Date();

  const { idUser } = useAuth();

  const [data, setData] = useState({
    school: {
      id: idUser,
    },
    label: formation?.label || null,
    convention: formation?.opcoConventionModel || null,
    description: formation?.description || null,
    workedLangage: formation?.workedLangage || [],
    cfa: {
      id: formation?.cfa?.id || null,
    },
    domain: {
      id: formation?.domain?.id || null,
    },
    degree: {
      id: formation?.degree?.id || null,
    },
    entryRequierement: {
      id: formation?.entryRequierement?.id || '',
    },
    address: {
      label: formation?.address?.label || '',
      cityCode: formation?.address?.cityCode || '',
      city: formation?.address?.city || '',
    },
    studyPlan: {
      id: formation?.studyPlan?.id || '',
    },
    trainingType: {
      id: formation?.trainingType?.id || '',
    },
    certifyingAuthority: {
      id: formation?.certifyingAuthority?.id || '',
    },
    duration: formation?.duration || null,
    onlyVerfiedProfile: formation?.onlyVerfiedProfile || false,
    registrationFees: formation?.registrationFees || 0,
    programCost: formation?.programCost || 0,
    openingDate: formation?.openingDate || null,
    closingDate: formation?.closingDate || null,
    applicationClosingDate:
      formation?.applicationClosingDate || null,
    applicationStartDate:
      formation?.applicationStartDate || null,
    rythmAlternance: {
      nbSchool: formation?.rythmAlternance?.split(' ')[0] || '',
      dayOrWeekSchool: formation?.rythmAlternance?.split(' ')[1] || '',
      nbBusiness: formation?.rythmAlternance?.split(' ')[3] || '',
      dayOrWeekBusiness: formation?.rythmAlternance?.split(' ')[4] || '',
    },
    rncp: formation?.rncp || null,
    diplomaType: formation?.diplomaType || null,
    diplomaCode: formation?.diplomaCode || null,
    diplomaLabel: formation?.diplomaLabel || null,
    trainingLabel: formation?.trainingLabel || null,
    trainingDuration: formation?.trainingDuration || null,
    trainingTotalCost: formation?.trainingTotalCost || null,
    opcoSupport: formation?.opcoSupport || null,
    businessCharge: formation?.businessCharge || null,
    foodNumber: formation?.foodNumber || null,
    foodCost: formation?.foodCost || null,
    accomodationNumber: formation?.accomodationNumber || null,
    accomodationCost: formation?.accomodationCost || null,
    requiredMaterialCost: formation?.requiredMaterialCost || null,
    internationalMobility: formation?.internationalMobility || false,
    drom: formation?.drom || false,
    cfaLocation: formation?.cfaLocation || false,
  });
  const [currentStep, setCurrentStep] = useState(0);

  const {
    error,
    isLoading: isLoadingUpdateFormation,
    isSuccess,
    mutateAsync: mutateUpdateFormation,
  } = useMutation(updateFormation);

  const { addToast } = useToast();

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour modifier la formation',
      });
    }
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Formation modifiée avec succès',
      });
      onClose();
      refetchFormation();
    }
  }, [error, isSuccess]);

  const makeRequest = async ({
    applicationClosingDate,
    applicationStartDate,
    openingDate,
    closingDate,
    ...values
  }) => {
    await mutateUpdateFormation({
      data: {
        openingDate: format(new Date(openingDate), "yyyy-MM-dd'T'HH:mm:ss"),
        closingDate: format(new Date(closingDate), "yyyy-MM-dd'T'HH:mm:ss"),
        applicationStartDate: format(
          new Date(applicationStartDate),
          "yyyy-MM-dd'T'HH:mm:ss"
        ),
        applicationClosingDate: format(
          new Date(applicationClosingDate),
          "yyyy-MM-dd'T'HH:mm:ss"
        ),
        opcoConventionModel: {
          id: values?.convention?.id
        },
        ...values,
      },
      id: formation?.id,
      from: 'cfa',
    });
  };

  const handleNextStep = (newData, final = false) => {
    setData((prev) => ({ ...prev, ...newData }));

    if (final) {
      makeRequest(newData);
      return;
    }

    setCurrentStep((prev) => prev + 1);
    onChangeStepModal((prev) => prev + 1);
  };

  const handlePrevStep = (newData) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
    onChangeStepModal((prev) => prev - 1);
  };

  const steps = [
    <StepOne
      key={1}
      addressLabel={formation?.address?.label}
      data={data}
      next={handleNextStep}
    />,
    <StepTwo key={2} data={data} next={handleNextStep} prev={handlePrevStep} />,
  ];

  return steps[currentStep];
};

EditFormation.propTypes = {
  onClose: PropTypes.func,
  refetchFormation: PropTypes.func,
  onChangeStepModal: PropTypes.func,
  formation: PropTypes.object,
};

const StepOne = ({ data, next }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const { data: convention = [] } = useQuery(getAllConventionModels, {
    key: ['convention', idUser],
    variables: {
      id: idUser,
    },
  });

  const formik = useFormik({
    initialValues: data,
    enableReinitialize: true,
    onSubmit: (values) => {
      values.rythmAlternance = `${values.rythmAlternance.nbSchool} ${values.rythmAlternance.dayOrWeekSchool} / ${values.rythmAlternance.nbBusiness} ${values.rythmAlternance.dayOrWeekBusiness}`;
      next(values);
    },
  });

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(2),
        }}
      >
        <Grid className={css({

        })} container>
          <Grid item xs={12}>
            <FormikTextField
              disabled
              formik={formik}
              fullWidth
              label="Nom de l'école"
              name="school.id"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              disabled
              formik={formik}
              fullWidth
              label="Nom de la formation"
              name="label"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikDatePicker
              disabled
              formik={formik}
              fullWidth
              variant='outlined'
              label="Rentrée scolaire"
              name="openingDate"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikDatePicker
              disabled
              formik={formik}
              fullWidth
              variant='outlined'
              label="Fin de la formation"
              name="closingDate"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              getOptionLabel={(option) => option.name || ''}
              label="Convention"
              name="convention"
              options={convention}
              value={convention.find((convention) => convention?.id === formik?.values?.convention?.id) || null}
              className={global.formikAutocomplete}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}
        style={{
          marginTop: spacing(3),
        }}
      >
        <Grid
          className={css({ textAlign: 'center' })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Suivant
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepOne.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  addressLabel: PropTypes.string,
};

const stepTwoValidationSchema = Yup.object({
  trainingDuration: Yup.string().required('Requis'),
});

const StepTwo = ({ data, next, prev }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const formik = useFormik({
    initialValues: data,
    validationSchema: stepTwoValidationSchema,
    onSubmit: (values) => next(values, true),
  });

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(2),
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Coût total pédagogique CFA (par an)"
              name="trainingTotalCost"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Prise en charge OPCO (par an)"
              name="opcoSupport"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Reste à charge éventuel de l'entreprise (par an)"
              name="businessCharge"
              type="number"
            />
          </Grid>
        </Grid>
        <div style={{ fontSize: '14px', color: '#152652', textAlign: 'center', marginTop: spacing(2) }}>Champs optionnels : </div>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Nombre de repas"
              name="foodNumber"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Coût de la nourriture par repas"
              name="foodCost"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Nombre de nuitées"
              name="accomodationNumber"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Coût du logement par nuitée"
              name="accomodationCost"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({})} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              label="Coût du matériel obligatoire"
              name="requiredMaterialCost"
              type="number"
            />
          </Grid>
        </Grid>
        <div>
          <Grid container>
            <FormLabel style={{ color: '#152652', alignSelf: 'center' }}>Mention mobilité internationale</FormLabel>
            <Checkbox
              className={css({ '.MuiIconButton-label': { color: '#152652 !important' } })}
              checked={formik.values.internationalMobility}
              name="internationalMobility"
              onChange={formik.handleChange}
              size="small"
              color='primary'
            />
          </Grid>
          <Grid container>
            <FormLabel style={{ color: '#152652', alignSelf: 'center' }}>Accompagnement DROM</FormLabel>
            <Checkbox
              className={css({ '.MuiIconButton-label': { color: '#152652 !important' } })}
              checked={formik.values.drom}
              name="drom"
              onChange={formik.handleChange}
              size="small"
              color='primary'
            />
          </Grid>
        </div>
      </Grid>
      <Grid container spacing={2}
        style={{
          marginTop: spacing(3),
        }}
      >
        <Grid
          className={css({
            textAlign: 'center',
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={() => prev(formik.values)}
            variant="outlined"
          >
            Retour
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            type="submit"
            variant="contained"
            onClick={formik.handleSubmit}
          >
            Modifier
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepTwo.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
};

export default EditFormation;
